export default class AnchorButtons extends HTMLElement {

	// static get observedAttributes() { return ['open', 'class']; }


	constructor() {
		super();
		this.init();
	}

	init() {
		this.anchors = Array.from(document.querySelectorAll('.anchor'))
		this.anchorTargets = this.anchors.map(a => ({
			id: a.getAttribute('id'),
			title: a.querySelector('h3').innerText
		}));
		this.container = document.createElement('nav')
		this.container.className = ' anchor-btns';
		this.buttons = this.anchorTargets.map(anchor => `<a href="#${anchor.id}" class="pill">${anchor.title}</a>`);
		this.buttons.forEach((btn) => {
			this.container.insertAdjacentHTML('beforeend', btn)
		})
		this.appendChild(this.container);
	}

	connectedCallback() {
		document.documentElement.style.setProperty("scroll-behavior", "smooth")
	}
	disconnectedCallback() {
		document.documentElement.style.removeProperty('scroll-behavior')
	}

}
